import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Sprout, Loader2, Check } from "lucide-react";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth-context";

export default function Signup() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    business_name: "", owner_name: "", email: "", phone: "", password: "",
  });
  const [loading, setLoading] = useState(false);
  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Password minimal 6 karakter");
      return;
    }
    setLoading(true);
    try {
      await signup(form);
      toast.success("Akun berhasil dibuat!");
      navigate("/onboarding");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup gagal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:flex bg-emerald-600 text-white p-12 flex-col justify-between relative overflow-hidden">
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(circle, #fff 1px, transparent 1px)", backgroundSize: "24px 24px" }} />
        <div className="relative">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="h-10 w-10 rounded-lg bg-white/20 backdrop-blur flex items-center justify-center">
              <Sprout className="text-white" strokeWidth={2.5} />
            </div>
            <span className="font-heading font-bold text-xl">Custora</span>
          </Link>
        </div>
        <div className="relative space-y-6">
          <h2 className="font-heading text-3xl lg:text-4xl font-bold leading-tight">
            Mulai kumpulkan<br />database pelanggan<br />hari ini.
          </h2>
          <ul className="space-y-2.5">
            {["14 hari gratis, tanpa kartu kredit", "Setup dalam 5 menit", "Support dalam bahasa Indonesia", "Cancel kapan pun"].map((t) => (
              <li key={t} className="flex items-center gap-2 text-emerald-50 text-sm">
                <div className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center">
                  <Check size={12} strokeWidth={3} />
                </div>
                {t}
              </li>
            ))}
          </ul>
        </div>
        <div className="relative text-xs text-emerald-100">© 2026 Custora</div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-white">
        <div className="w-full max-w-md">
          <div className="md:hidden mb-8"><Logo /></div>
          <h1 className="font-heading text-3xl font-bold text-gray-900">Buat akun gratis</h1>
          <p className="mt-2 text-gray-600 text-sm">Mulai coba Custora 14 hari tanpa biaya.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="business_name">Nama Toko / Brand</Label>
              <Input id="business_name" required value={form.business_name} onChange={update("business_name")}
                placeholder="Contoh: Glow Baby Skincare" className="mt-1.5 h-11" data-testid="signup-business-input" />
            </div>
            <div>
              <Label htmlFor="owner_name">Nama Owner</Label>
              <Input id="owner_name" required value={form.owner_name} onChange={update("owner_name")}
                placeholder="Nama lengkap Anda" className="mt-1.5 h-11" data-testid="signup-owner-input" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={form.email} onChange={update("email")}
                  placeholder="owner@brand.com" className="mt-1.5 h-11" data-testid="signup-email-input" />
              </div>
              <div>
                <Label htmlFor="phone">WhatsApp</Label>
                <Input id="phone" required value={form.phone} onChange={update("phone")}
                  placeholder="081234567890" className="mt-1.5 h-11" data-testid="signup-phone-input" />
              </div>
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" required value={form.password} onChange={update("password")}
                placeholder="Minimal 6 karakter" className="mt-1.5 h-11" data-testid="signup-password-input" />
            </div>

            <Button type="submit" disabled={loading}
              className="w-full h-11 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold"
              data-testid="signup-submit-button">
              {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
              Daftar Gratis
            </Button>

            <div className="text-xs text-gray-500 text-center">
              Dengan mendaftar, Anda menyetujui Syarat & Ketentuan dan Kebijakan Privasi.
            </div>
          </form>

          <div className="mt-6 text-center text-sm text-gray-600">
            Sudah punya akun?{" "}
            <Link to="/login" className="text-emerald-600 font-semibold hover:underline" data-testid="signup-to-login-link">
              Masuk
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
